import React from "react"

/**
 * Mutes deeply all child components that consume this context.
 */
export const DisableProGloveDisplayContext = React.createContext(false)

DisableProGloveDisplayContext.displayName = "DisableProGloveDisplayContext"
